

import React, { PureComponent } from 'react';
import $ from 'jquery'
// import "@uefa/design-system/dist/golazo/golazo.css";




class App extends PureComponent {
    constructor(props) {

        super(props);
        this.state = {
        }
    }

    avoidConsoles = () => {

        let method;
        const noop = function () {
        };
        const methods = [
            'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
            'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
            'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
            'timeStamp', 'trace', 'warn'
        ];
        let length = methods.length;
        const console = (window.console = window.console || {});
        while (length--) {
            method = methods[length];
            // Only stub undefined methods.
            if (console[method]) {
                console[method] = noop;
            }
        }
    }

    componentDidMount() {
        //comment console's
        $('#loaderWrap').hide();

    }



    //config api call no config setup at local
    //
    render() {
        return (

            <g-h-c language="en" passivemode="false" season="2020"></g-h-c>)
    }
}

export default App;
